import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast, TextArea, Modal } from 'antd-mobile-v5';
import reporting_body from '../../static/images_ae/reporting/reporting_body.png';
import area_head from '../../static/images_ae/reporting/area_head.png';
import line_head from '../../static/images_ae/reporting/line_head.png';
import area_chest from '../../static/images_ae/reporting/area_chest.png';
import line_chest from '../../static/images_ae/reporting/line_chest.png';
import area_stomach from '../../static/images_ae/reporting/area_stomach.png';
import line_stomach from '../../static/images_ae/reporting/line_stomach.png';
import area_others from '../../static/images_ae/reporting/area_others.png';
import line_others from '../../static/images_ae/reporting/line_others.png';
import line_heart from '../../static/images_ae/reporting/line_heart.png';
import line_lungs from '../../static/images_ae/reporting/line_lungs.png';
import area_four_limbs from '../../static/images_ae/reporting/area_four_limbs.png';
import line_four_limbs from '../../static/images_ae/reporting/line_four_limbs.png';
import tip_top_select from '../../static/images_ae/reporting/tip_top_select.png';
import sympton_bg from '../../static/images_ae/reporting/sympton_bg.png';
import bg_back from '../../static/images_ae/reporting/bg_back.png';
import bg_finish_go_on from '../../static/images_ae/reporting/bg_finish_go_on.png';
import tip_bottom_select from '../../static/images_ae/reporting/tip_bottom_select.png';
import organ_heart from '../../static/images_ae/reporting/organ_heart.png';
import organ_lung from '../../static/images_ae/reporting/organ_lung.png';
import { withRouter } from 'react-router-dom';
import styles from './chest.module.scss';

const api = new ApiCore();

const Chest = (props: any) => {

    const [list, setList] = useState<any>([]);
    const [headSelected, setHeadSelected] = useState<any>(true);
    const [chestSelected, setChestSelected] = useState<any>(false);
    const [stomachSelected, setStomachSelect] = useState<any>(false);
    const [othersSelected, setOthersSelected] = useState<any>(false);
    const [fourLimbsSelected, setFourLimbsSelected] = useState<any>(false);
    const [selectedCount, setSelectedCount] = useState<any>(0);
    const [organs, setOrgans] = useState<any>(props.organs || {});
    const [organList, setOrganList] = useState<any>([]);
    const [symptoms, setSymptoms] = useState<any>([]);
    const [activeOrgan, setActiveOrgan] = useState<any>('lung');
    const [brainIntro, setBrainIntro] = useState<any>('');
    const [eyeIntro, setEyeIntro] = useState<any>('');
    const [value, setValue] = useState<any>('');
    const [visible, setVisible] = useState<any>(false);
    const [lungSelectedCount, setLungSelectedCount] = useState<any>(0);
    const [heartSelectedCount, setHeartSelectedCount] = useState<any>(0);

    useEffect(() => {
        window.document.title = 'ALK风险评估';
        initData();
        return () => {
            window.removeEventListener('popstate', onPopState);
        }
    }, [])

    useEffect(() => {
        let _selectedCount = 0;
        [headSelected, chestSelected, stomachSelected, othersSelected, fourLimbsSelected].forEach((val: any) => {
            if (val) {
                _selectedCount++;
            }
        })
        setSelectedCount(_selectedCount);
    }, [headSelected, chestSelected, stomachSelected, othersSelected, fourLimbsSelected])

    const initData = () => {
        window.addEventListener('popstate', onPopState)
        let _organs = props.organs;
        _organs.organs = _organs.organs.map((vvv: any) => {
            if (vvv.type === 'lung') {
                setBrainIntro(vvv.remark);
            } else if (vvv.type === 'heart') {
                setEyeIntro(vvv.remark);
            }
            const _lastItem = vvv.symptoms[vvv.symptoms.length -1] || {};
            if (_lastItem && _lastItem.code === '') {
                return vvv;
            } else {
                const symptoms = vvv.symptoms.concat({
                    code: '',
                    name: '其他',
                    organCode: vvv.code
                })
                return {
                    ...vvv,
                    symptoms
                }
            }

        })
        setOrgans(_organs);
        let _list = organs.organs || []
        if (_list) {
            setOrganList(_list);
        }
        // 还原选中状态
        setOrganSelectedActive(_list);
    }

    const headSelect = () => {
        // setHeadSelected(!headSelected);
        // setChestSelected(false);
        setActiveOrgan('lung');
        // setActiveOrgan('heart');
        // const item = organList.filter((item: any) => item.type === 'heart');
        // setSymptoms(item);
    }

    const chestSelect = () => {
        // const item = organList.filter((item: any) => item.type === 'lung');
        // setSymptoms(item);
        
        // setChestSelected(!chestSelected);
        // setHeadSelected(false);
        setActiveOrgan('heart');
    }

    const stomachSelect = () => {
        setStomachSelect(!stomachSelected);
    }

    const othersSelect = () => {
        setOthersSelected(!othersSelected);
    }

    const fourLimbsSelect = () => {
        setFourLimbsSelected(!fourLimbsSelected);
    }

    const symptomsSelected = (val: any, key: number) => {
        if (!val.code) {
            // 其他选项输入
            organList.some((val: any, key: number) => {
                if (activeOrgan === val.type) {
                    const _lastItem = val.symptoms[val.symptoms.length -1] || {};
                    if (_lastItem && _lastItem.code === '') {
                        setValue(_lastItem.value || '');
                        return true;
                    }
                }
            })
            setVisible(true);
            return;
        }
        let _lungCount = 0;
        let _heartCount = 0;
        const _list = organList.map((item: any) => {
            let _symptoms: any = item.symptoms.map((v: any) => {
                let _selected = !!v.selected;
                if (val.code === v.code) {
                    _selected = !v.selected;
                }
                if (item.type === 'lung') {
                    // 输入其他时
                    if (!v.code) {
                        if (v.value) {
                            _selected = true;
                        } else {
                            _selected = false;
                        }
                    }
                    if (_selected) {
                        _lungCount++;
                    }
                } else if (item.type === 'heart') {
                    // 输入其他时
                    if (!v.code) {
                        if (v.value) {
                            _selected = true;
                        } else {
                            _selected = false;
                        }
                    }
                    if (_selected) {
                        _heartCount++;
                    }
                }
                return {
                    ...v,
                    selected: _selected
                }
            });
            return {
                ...item,
                symptoms: _symptoms
            }
            // let selected = !!item.selected;
            // if (val.code === item.code) {
            //     selected = true;
            // }
            // return {
            //     selected: selected,
            //     ...item
            // }
        });
        setHeadSelected(_lungCount > 0);
        setChestSelected(_heartCount > 0);
        setLungSelectedCount(_lungCount);
        setHeartSelectedCount(_heartCount);
        setOrganList(_list);
        const _organs = organs;
        _organs.organs = _list;
        setOrgans(_organs)
    }
    
    const setOrganSelectedActive = (mOrganList?: any) => {
        let _lungCount = 0;
        let _heartCount = 0;
        let _organList = mOrganList || organList;
        _organList.forEach((item: any) => {
            item.symptoms.forEach((v: any) => {
                let _selected = v.selected;
                if (item.type === 'lung') {
                    if (_selected) {
                        _lungCount++;
                    }
                } else if (item.type === 'heart') {
                    if (_selected) {
                        _heartCount++;
                    }
                }
            });
        });
        setHeadSelected(_lungCount > 0);
        setChestSelected(_heartCount > 0);
        setLungSelectedCount(_lungCount);
        setHeartSelectedCount(_heartCount);
    }

    const setOtherValue = (value: any) => {
        let _organs = organs;
        _organs.organs = _organs.organs.map((vvv: any) => {
            const _lastItem = vvv.symptoms[vvv.symptoms.length -1] || {};
            if (_lastItem && _lastItem.code === '') {
                const symptoms = vvv.symptoms.map((vv: any) => {
                    if (activeOrgan === vvv.type && vv.code === '') {
                        let selected = !!value;
                        return {
                            code: '',
                            name: '其他',
                            value: value,
                            selected: selected,
                            organCode: vv.organCode
                        }
                    } else {
                        return vv;
                    }

                })
                return {
                    ...vvv,
                    symptoms
                }
            } else {
                return vvv;
            }

        })
        setOrgans(_organs)
        let _list = _organs.organs || []
        if (_list) {
            setOrganList(_list);
        }
        return _list;
    }

    const onPopState = (event: any) => {
        props.onBack();
    }

    return (
        <div className={styles.ae_reporting}>
            {/* <div className={styles.tip_top_wrap}>
                <img className={styles.tip_top} src={tip_top_select} alt="" />
                <div className={styles.tip_top_text}>请从下列5个部位中选择您出现不适的部位</div>
            </div> */}
            <div className={styles.area_body_container}>
                <img className={styles.area_body} src={reporting_body} alt="" />
                <div className={`${styles.area_base} ${styles.area_head} ${headSelected ? styles.area_active : ''} ${activeOrgan === 'lung' ? styles.active : styles.in_active}`} onClick={ () => { headSelect()} }>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>
                    {
                        lungSelectedCount > 0 &&
                        <div className={styles.rtSelectedCount}>
                            {lungSelectedCount}个症状
                        </div>
                    }
                    <div className={styles.area_head_top}>
                        <img className={styles.icon_head} src={organ_lung} alt="" />
                        <div>肺部</div>
                    </div>
                    {
                        activeOrgan === 'lung' &&
                        <>
                            <div className={styles.area_head_middle}>
                            </div>
                            <div className={styles.area_head_bottom}>
                                {brainIntro}
                            </div>
                        </>
                    }
                    <img  className={styles.line_head} src={line_lungs} alt="" />
                </div>
                <div className={`${styles.area_base} ${styles.area_chest} ${chestSelected ? styles.area_active : ''} ${activeOrgan === 'heart' ? styles.active : styles.in_active}`} onClick={ () => { chestSelect()} }>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>
                    {
                        heartSelectedCount > 0 &&
                        <div className={styles.ltSelectedCount}>
                            {heartSelectedCount}个症状
                        </div>
                    }
                    <div className={styles.area_head_top}>
                        <img className={styles.icon_head} src={organ_heart} alt="" />
                        <div>心脏</div>
                    </div>
                    {
                        activeOrgan === 'heart' &&
                        <>
                            <div className={styles.area_head_middle}>
                            </div>
                            <div className={styles.area_head_bottom}>
                                {eyeIntro}
                            </div>  
                        </>
                    }
                    <img  className={styles.line_chest} src={line_heart} alt="" />
                </div>
            </div>
            <div className={styles.sympton_select}>
                <div className={styles.sympton_select_img_wrap}>
                    <img src={sympton_bg} alt="" />
                </div>
                <div className={styles.sympton_select_text_wrap}>
                    <div className={styles.sympton_select_text}>请选择一个或多个与您症状贴近的病症描述：</div>
                    <div className={styles.sympton_select_menu}>
                        {/* {
                            symptoms && symptoms.map((val: any, key: number) => (
                                <div className={`${val.selected ? styles.menu_active : ''}`} onClick={() => { symptomsSelected(val, key) }}>{val.name}</div>
                            ))
                        } */}
                        {
                            organList.map((val: any, key: number) => {
                                if (activeOrgan === val.type) {
                                    return val.symptoms.map((val: any, iKey: number) => (
                                        <div key={iKey} className={`${val.selected ? styles.menu_active : ''}`} onClick={() => { symptomsSelected(val, key) }}>{val.name}</div>
                                    ))
                                }
                            })
                        }
                    </div>
                </div>
            </div>
            <div className={styles.btns_wrap}>
                <div className={styles.btns_back}>
                    <img className={styles.bootom_top} src={bg_back} alt="" />
                    <div className={styles.text} onClick={() => { props.history.go(-1); props.onBack() }}>返回上一步</div>
                </div>
                <div className={styles.btns_finish_go_on}>
                    <img className={styles.bootom_top} src={bg_finish_go_on} alt="" />
                    <div className={styles.text} onClick={() => { props.history.go(-1); props.onComplete('chest', organList) }}>选择完成，继续评测</div>
                </div>
            </div>
            <Modal
                visible={visible}
                content={
                    <TextArea
                        placeholder='请输入内容'
                        value={value}
                        onChange={val => {
                            setValue(val)
                        }}
                    />
                }
                // closeOnMaskClick
                closeOnAction
                onClose={() => {
                    setOrganSelectedActive(setOtherValue(value));
                    setVisible(false)
                }}
                actions={[
                    {
                        key: 'confirm',
                        text: '确定',
                    },
                ]}
            >
            </Modal>
        </div>
    )
}

export default withRouter(Chest);